import { render, staticRenderFns } from "./FooterSocial.vue?vue&type=template&id=531e5322&scoped=true&"
import script from "./FooterSocial.vue?vue&type=script&lang=js&"
export * from "./FooterSocial.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocial.vue?vue&type=style&index=0&id=531e5322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e5322",
  null
  
)

export default component.exports